let performanceMeasureNumber: number = 0;

export async function measurePerfAsync<T>(measureName: string, asyncFunc: () => Promise<T>): Promise<T> {
  const startingMarkName = `measurePerfAsync_${performanceMeasureNumber++}}`;
  window.performance.mark(startingMarkName);
  const returnValue = await asyncFunc();
  window.performance.measure(measureName, startingMarkName);
  return returnValue;
}
